// Returns true if there is no HOST_ENV (aka ruunning locallly)
const isDev = () => {
  return !process.env.REACT_APP_HOST_ENV;
};

export default isDev;
